import { NgPageHeader, AgencyFeatureView } from '@/ui';
import {
  selectCurrentlyOpenIncidents,
  selectForwardedIncidents,
  selectRecentClosedIncidents,
  toRow,
} from '@ngsos/portal-core/incidents';
import { useAgencyConfiguration } from '@/app/shell/agencyConfiguration';
import type { Incident, PortalCall } from '@/signalr/contracts';
import type { IncidentListContext } from './incidentListContext';
import { IncidentListPageList } from './IncidentListPageList';
import { IncidentListTab } from './IncidentListTab';

export type IncidentListContentProps = {
  isLoading?: boolean;
  incidents: readonly Incident[];
  callNotifications: readonly PortalCall[];
  onTabSwitch?: (context: IncidentListContext) => void;
};

export function IncidentListContent({
  isLoading = true,
  incidents,
  callNotifications,
  onTabSwitch,
}: IncidentListContentProps) {
  const agencyId = useAgencyConfiguration().id;

  const forwarded = selectForwardedIncidents(incidents, agencyId);
  const currentlyOpen = selectCurrentlyOpenIncidents(incidents, agencyId);
  const recentClosed = selectRecentClosedIncidents(incidents, agencyId);

  const forwardedIncidents = forwarded.map(toRow);
  const currentlyOpenIncidents = currentlyOpen.map(toRow);
  const recentClosedIncidents = recentClosed.map(toRow);

  const incidentsCount = forwarded.length + currentlyOpen.length;
  const totalNotificationsCount = incidentsCount + callNotifications.length;

  return (
    <AgencyFeatureView
      emergencyCallNotification
      whenEnabled={
        <>
          <NgPageHeader title={`(${totalNotificationsCount})`} separator=" " />
          <IncidentListTab
            isLoading={isLoading}
            forwardedIncidents={forwardedIncidents}
            currentlyOpenIncidents={currentlyOpenIncidents}
            recentClosedIncidents={recentClosedIncidents}
            incidents={incidents}
            callNotifications={callNotifications}
            onTabSwitch={onTabSwitch}
          />
        </>
      }
      whenDisabled={
        <>
          <NgPageHeader title={`(${incidentsCount})`} separator=" " />
          <IncidentListPageList
            forwardedIncidents={forwardedIncidents}
            currentlyOpenIncidents={currentlyOpenIncidents}
            recentClosedIncidents={recentClosedIncidents}
            isLoading={isLoading}
          />
        </>
      }
    />
  );
}
